<vi-page [sidenavs]="true" [footer]="true" [isWhiteBackground]="true">
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>
  <vi-toolbar head color="white">
    <vi-back-button left gtm="onBreadcrumbBack" gtmCategory="booking"></vi-back-button>
    <vi-breadcrumbs
      left
      gtm="onBreadcrumb"
      gtmCategory="booking"
      formerPage="{{ 'GENERAL.PATH.OVERVIEW' | translate }}"
      currentPage="{{ 'GENERAL.PATH.BOOKING' | translate }}"
      [navigateTo]="'/installations'"
    ></vi-breadcrumbs>
  </vi-toolbar>

  <vi-content body [centered]="true">
    <ng-container *ngIf="bookingStore.loaded$ | async; else loader" main>
      <mat-horizontal-stepper #stepper [selectedIndex]="currentStep">
        <mat-step #first_step>
          <ng-template matStepLabel>{{ '+BOOKING.STEPPER.SELECT_PLAN' | translate }}</ng-template>
          <ng-template matStepperIcon="edit">
            <mat-icon>check</mat-icon>
          </ng-template>

          <ng-container *ngIf="stepper.selected === null || stepper.selected === first_step">
            <ng-container
              *ngIf="
                (bookingStore.error$ | async) === noInstallationsError;
                then bookingPlansError;
                else bookingPlansVoucher
              "
            ></ng-container>
            <ng-template #bookingPlansVoucher>
              <app-booking-plans-voucher
                (planSelected)="nextStep(stepper)"
                (trialPlanSelected)="initTrialStep(stepper)"
              >
              </app-booking-plans-voucher>
            </ng-template>
            <ng-template #bookingPlansError>
              <div
                class="error-container flex flex-col gap-[24px] lt-md:gap-[16px] justify-start items-center"
              >
                <img class="error-img" src="assets/img/installer-error.svg" />
                <h1>{{ '+BOOKING.PLANS.ERROR.TITLE' | translate }}</h1>
                <button
                  class="back-button"
                  gtm="onGoToPage"
                  gtmAction="Home Page"
                  gtmCategory="booking"
                  mat-raised-button
                  color="primary"
                  (click)="goToInstallations()"
                >
                  <mat-icon>arrow_back</mat-icon>
                  <span>{{ '+BOOKING.PLANS.ERROR.BTN' | translate }}</span>
                </button>
              </div>
            </ng-template>
          </ng-container>
        </mat-step>

        <mat-step #second_step>
          <ng-template matStepLabel>{{
            '+BOOKING.STEPPER.SELECT_DEVICES' | translate
          }}</ng-template>
          <ng-template matStepperIcon="edit">
            <mat-icon>check</mat-icon>
          </ng-template>

          <ng-container *ngIf="stepper.selected === second_step">
            <app-booking-voucher-devices
              (navigateToCheckout)="navigateToCheckout(stepper)"
              (nextPage)="nextStep(stepper)"
              (back)="previousStep(stepper)"
            ></app-booking-voucher-devices>
          </ng-container>
        </mat-step>

        <mat-step #third_step>
          <ng-template matStepLabel>{{ '+BOOKING.STEPPER.ACTIVATE_CODE' | translate }}</ng-template>
          <ng-template matStepperIcon="edit">
            <mat-icon>check</mat-icon>
          </ng-template>

          <ng-container *ngIf="stepper.selected === third_step">
            <app-booking-voucher-checkout
              (reset)="initialStep(stepper)"
              (back)="previousStep(stepper)"
            ></app-booking-voucher-checkout>
          </ng-container>
        </mat-step>
      </mat-horizontal-stepper>
    </ng-container>
  </vi-content>
  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>

<ng-template #loader>
  <vi-loader main data-at-loader [isLoading]="true"></vi-loader>
</ng-template>
